
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kids",
      function () {
        return require("private-next-pages/kids.tsx");
      }
    ]);
  